<section class="report-page-min-height grid gap-5 content-start">
  <h1 class="mb-4">Generowanie raportu</h1>

  <form class="grid gap-5" [formGroup]="formGroup()!">
    <div class="grid gap-5 rounded-lg border border-gray-200 bg-white p-5">
      <div class="flex flex-col gap-2">
        <span
          id="report-type-label"
          class="font-semibold"
          appRequiredLabel="rodzaj raportu"
        >
          Rodzaj raportu
        </span>
        <div class="mt-1 flex flex-wrap items-center gap-4">
          @for (option of nameOptions; track option.value) {
            <div class="flex items-center gap-2">
              <p-radio-button
                [inputId]="'report-type-' + option.value"
                [value]="option.value"
                [formControl]="formGroup().controls.nazwa"
                class="customRadioButton"
                [attr.aria-labelledby]="'report-type-label'"
              />
              <label [for]="'report-type-' + option.value" class="font-normal">
                {{ option.label }}
              </label>
            </div>
          }
        </div>
      </div>

      @if (
        formGroup().controls.nazwa.value
          | isReportType: reportNames.BASIC_APPLICATION_REPORT
      ) {
        <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-6">
          <div class="flex flex-col gap-2">
            <label for="date-from" class="font-semibold">
              Data od
              <span class="text-red-500">*</span>
            </label>
            <p-date-picker
              inputId="date-from"
              class="w-full customDatePicker"
              dateFormat="yy-mm-dd"
              [showClear]="true"
              [readonlyInput]="true"
              [showIcon]="true"
              [iconDisplay]="'input'"
              appendTo="body"
              [formControl]="formGroup().controls.dataOd"
              [maxDate]="formGroup().controls.dataDo.value ?? null"
              appControlError
            ></p-date-picker>
          </div>

          <div class="flex flex-col gap-2">
            <label for="date-from" class="font-semibold">
              Data do <span class="text-red-500">*</span>
            </label>
            <p-date-picker
              inputId="date-to"
              class="w-full customDatePicker"
              dateFormat="yy-mm-dd"
              [showClear]="true"
              [readonlyInput]="true"
              [showIcon]="true"
              [iconDisplay]="'input'"
              appendTo="body"
              [formControl]="formGroup().controls.dataDo"
              [minDate]="formGroup().controls.dataOd.value ?? null"
              appControlError
            ></p-date-picker>
          </div>

          <div class="hidden md:block"></div>
        </div>
      }

      @if (
        formGroup().controls.nazwa.value
          | isReportType: reportNames.COMPARATIVE_APPLICATION_REPORT
      ) {
        <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-6">
          <div class="flex flex-col gap-2">
            <span id="cycleLabel" appRequiredLabel="cycle" class="font-semibold"
            >Cykl porównawczy
              <span class="text-red-500">*</span>
            </span>
            <p-select
              ariaLabelledBy="cycleLabel"
              class="w-full"
              [options]="cycleOptions"
              [filter]="false"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [formControl]="formGroup().controls.cykl"
              appControlError
            ></p-select>
          </div>

          <div class="flex flex-col gap-2">
            <label
              for="year-from"
              appRequiredLabel="yearFrom"
              class="font-semibold">
              Rok
              <span class="text-red-500">*</span>
            </label>
            <p-datepicker
              inputId="year-from"
              [formControl]="formGroup().controls.rok"
              [readonlyInput]="true"
              [showClear]="true"
              [iconDisplay]="'input'"
              [maxDate]="formGroup().controls.doRoku.value ?? null"
              class="w-full customDatePicker"
              view="year"
              dateFormat="yy"
              [showIcon]="true"
              appendTo="body"
              appControlError
            >
            </p-datepicker>
          </div>

          <div class="flex flex-col gap-2">
            <label for="year-to" appRequiredLabel="yearTo" class="font-semibold">
              Do roku
              <span class="text-red-500">*</span>
            </label>
            <p-datepicker
              inputId="year-to"
              [formControl]="formGroup().controls.doRoku"
              [readonlyInput]="true"
              [showClear]="true"
              [iconDisplay]="'input'"
              [minDate]="formGroup().controls.rok.value ?? null"
              ariaLabelledBy="yearToLabel"
              class="w-full customDatePicker"
              view="year"
              dateFormat="yy"
              appendTo="body"
              [showIcon]="true"
              appControlError
            >
            </p-datepicker>
          </div>
        </div>

        @if (cykl === CompareCycle.HALF_YEAR) {
          <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-6">
            <div class="flex flex-col gap-2">
              <span id="halfFromLabel" appRequiredLabel="halfFrom" class="font-semibold">
                Półrocze
                <span class="text-red-500">*</span>
              </span>
              <p-select
                ariaLabelledBy="halfFromLabel"
                class="w-full"
                [options]="halfOptions"
                [filter]="false"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [formControl]="formGroup().controls.polrocze"
                appControlError
              ></p-select>
            </div>

            <div class="flex flex-col gap-2">
              <span id="halfToLabel" appRequiredLabel="halfTo" class="font-semibold">
                Do półrocza
                <span class="text-red-500">*</span>
              </span>
              <p-select
                ariaLabelledBy="halfToLabel"
                class="w-full"
                [options]="halfOptions"
                [filter]="false"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [formControl]="formGroup().controls.doPolrocza"
                appControlError
              ></p-select>
            </div>

            <div class="hidden md:block"></div>
          </div>
        }

        @if (cykl === CompareCycle.QUARTER) {
          <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-6">
            <div class="flex flex-col gap-2">
              <span id="quarterFromLabel" appRequiredLabel="quarterFrom" class="font-semibold">
                Kwartał
                <span class="text-red-500">*</span>
              </span>
              <p-select
                ariaLabelledBy="quarterFromLabel"
                class="w-full"
                [options]="quarterOptions"
                [filter]="false"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [formControl]="formGroup().controls.kwartal"
                appControlError
              ></p-select>
            </div>

            <div class="flex flex-col gap-2">
              <span id="quarterToLabel" appRequiredLabel="quarterTo" class="font-semibold">
                Do kwartału
                <span class="text-red-500">*</span>
              </span>
              <p-select
                ariaLabelledBy="quarterToLabel"
                class="w-full"
                [options]="quarterOptions"
                [filter]="false"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [formControl]="formGroup().controls.doKwartalu"
                appControlError
              ></p-select>
            </div>

            <div class="hidden md:block"></div>
          </div>
        }

        @if (cykl === CompareCycle.MONTH) {
          <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-6">
            <div class="flex flex-col gap-2">
              <span id="monthFromLabel" appRequiredLabel="monthFrom" class="font-semibold">
                Miesiąc
                <span class="text-red-500">*</span>
              </span>
              <p-select
                ariaLabelledBy="monthFromLabel"
                class="w-full"
                [options]="monthOptions"
                [filter]="false"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [formControl]="formGroup().controls.miesiac"
                appControlError
              ></p-select>
            </div>

            <div class="flex flex-col gap-2">
              <span id="monthToLabel" appRequiredLabel="monthTo" class="font-semibold">
                Do miesiąca
                <span class="text-red-500">*</span>
              </span>
              <p-select
                ariaLabelledBy="monthToLabel"
                class="w-full"
                [options]="monthOptions"
                [filter]="false"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [formControl]="formGroup().controls.doMiesiac"
                appControlError
              ></p-select>
            </div>

            <div class="hidden md:block"></div>
          </div>
        }
      }

      @if (formGroup().controls.nazwa.value | isNotNull) {
        <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-6">
          <div class="flex flex-col gap-2">
            <span id="applicationTypeLabel" class="font-semibold">
              Nazwa wniosku
            </span>
            <p-multiSelect
              ariaLabelledBy="applicationTypeLabel"
              [panelStyle]="{ minWidth: '300px', maxWidth: '500px' }"
              [options]="applicationTypeOptions"
              [selectedItemsLabel]="getSelectedItemsLabel(formGroup().controls.rodzajWnioskuCode.value)"
              [showToggleAll]="true"
              panelStyleClass="custom-application-type-multiselect"
              filter
              optionLabel="label"
              optionValue="value"
              display="chip"
              appendTo="body"
              [formControl]="formGroup().controls.rodzajWnioskuCode"
            >
            </p-multiSelect>
          </div>

          <div class="flex flex-col gap-2">
            <span id="statusLabel" class="font-semibold"> Status wniosku </span>
            <p-multiSelect
              ariaLabelledBy="statusLabel"
              class="w-full"
              [selectedItemsLabel]="getSelectedItemsLabel(formGroup().controls.statusWniosku.value)"
              [options]="statusOptions"
              filter
              [showToggleAll]="true"
              optionLabel="label"
              optionValue="value"
              display="chip"
              appendTo="body"
              [formControl]="formGroup().controls.statusWniosku"
            >
            </p-multiSelect>
          </div>

          <div class="hidden md:block"></div>
        </div>
      }
    </div>

    <div class="flex justify-end gap-3">
      <p-button
        type="button"
        label="Anuluj"
        styleClass="customInfoButton outlined"
        (onClick)="onCancel()"
        [disabled]="isSubmitting()"
      ></p-button>
      <p-button
        type="button"
        label="Wygeneruj"
        styleClass="customInfoButton"
        (onClick)="onGenerate()"
        [disabled]="isSubmitting()"
      ></p-button>
    </div>
  </form>
</section>
